import { useServices } from '@/shared/services'
import type { RuntimeConfig } from './schema'

/** The only way UI code reads runtime configuration. */
export function useConfig(): RuntimeConfig {
  return useServices().config
}
